export const ADD_TTP_INFO = 'ADD_TTP_INFO'

export function ttpInfoReducer (state = {}, action) {
    switch (action.type){
        case ADD_TTP_INFO:
            return action.payload
        default: return state
    }
}